import { render } from "./OrderHistoryModal.vue?vue&type=template&id=bbe94e02&scoped=true"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=js"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=js"

import "./OrderHistoryModal.vue?vue&type=style&index=0&id=bbe94e02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe94e02"]])

export default __exports__